/* =========================================================================
   RETAILER × StockX — WISHLIST ("Saved")
   localStorage-backed. No Dawn wishlist backend exists.
   - Stores product handles in localStorage['sx_saved'].
   - Toggles the PDP heart (.sx-pdp__wishlist) only — NOT grid cards.
   - Updates the bottom-tab "Saved" badge count.
   - Renders saved products client-side on /pages/saved via Shopify JS
     product endpoints (handle.js), with .sx-empty empty-state.
   Decision-gate default: SHIP (Owen committed YES).
   NOTE: a real Shopify page with handle "saved" + template "page.sx-saved"
   must be created in admin before publish — flagged in build risks.
   ========================================================================= */
(function () {
  'use strict';

  var KEY = 'sx_saved';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function write(arr) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {}
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    if (!handle) return false;
    var arr = read();
    var i = arr.indexOf(handle);
    var saved;
    if (i === -1) {
      arr.push(handle);
      saved = true;
    } else {
      arr.splice(i, 1);
      saved = false;
    }
    write(arr);
    syncCount();
    document.dispatchEvent(
      new CustomEvent('sx:saved-changed', { detail: { handle: handle, saved: saved } })
    );
    return saved;
  }

  function count() {
    return read().length;
  }

  /* ---- Bottom-tab "Saved" badge ---- */
  function syncCount() {
    var n = count();
    document.querySelectorAll('[data-sx-saved-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.classList.toggle('is-visible', n > 0);
    });
    // /pages/saved header count, e.g. "Saved (5)"
    document.querySelectorAll('[data-sx-saved-headcount]').forEach(function (el) {
      el.textContent = n ? ' (' + n + ')' : '';
    });
  }

  /* ---- PDP heart wiring ---- */
  function paintHeart(btn) {
    var handle = btn.getAttribute('data-sx-wishlist');
    var on = has(handle);
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var label = btn.querySelector('[data-sx-wishlist-label]');
    if (label) label.textContent = on ? 'Saved' : 'Save';
  }

  function bindHearts() {
    document.querySelectorAll('[data-sx-wishlist]').forEach(function (btn) {
      if (btn.__sxBound) return;
      btn.__sxBound = true;
      paintHeart(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(btn.getAttribute('data-sx-wishlist'));
        paintHeart(btn);
      });
    });
  }

  document.addEventListener('sx:saved-changed', function () {
    document.querySelectorAll('[data-sx-wishlist]').forEach(paintHeart);
  });

  /* ---- /pages/saved client render ---- */
  function money(cents) {
    var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var v = (cents / 100).toFixed(2);
    return (c ? c + ' ' : '$') + v;
  }

  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    // Shopify CDN URLs usually carry ?v=…; append width with the correct
    // separator so a param-less URL isn't broken by a stray "&".
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function cardHTML(p) {
    var title = esc(p.title);
    var src = imgUrl(p.featured_image || (p.images && p.images[0]) || '', 400);
    // Always render a square media: real image, or a neutral placeholder so an
    // image-less product keeps the card's height and the grid never breaks.
    var media = src
      ? '<img src="' + src + '" alt="' + title + '" loading="lazy">'
      : '<div class="sx-saved-card__noimg" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
            '<rect x="3" y="3" width="18" height="18" rx="2"/>' +
            '<circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>' +
          '</svg></div>';
    var price = money(p.price);
    var rrp =
      p.compare_at_price && p.compare_at_price > p.price
        ? '<s class="sx-card__rrp">' + money(p.compare_at_price) + '</s>'
        : '';
    return (
      '<div class="sx-card sx-saved-card" data-sx-saved-card="' + esc(p.handle) + '">' +
        '<a class="sx-card__link" href="/products/' + esc(p.handle) + '" aria-label="' + title + '"></a>' +
        '<div class="sx-card__media">' + media + '</div>' +
        '<div class="sx-card__eyebrow">' + esc(p.vendor) + '</div>' +
        '<div class="sx-card__title">' + title + '</div>' +
        '<div class="sx-card__price-block">' +
          '<span class="sx-card__price">' + price + '</span>' + rrp +
        '</div>' +
        '<button type="button" class="sx-saved-card__remove" ' +
          'data-sx-remove="' + esc(p.handle) + '" aria-label="Remove from saved">Remove</button>' +
      '</div>'
    );
  }

  function emptyHTML() {
    return (
      '<div class="sx-empty">' +
        '<svg class="sx-empty__glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
          '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
        '</svg>' +
        '<div class="sx-empty__headline">Nothing saved yet</div>' +
        '<div class="sx-empty__sub">Tap the heart on any product to save it here.</div>' +
        '<a class="sx-btn sx-btn--primary" href="/collections/all">Start browsing</a>' +
      '</div>'
    );
  }

  function renderSaved(mount) {
    if (!mount) return;
    var handles = read();
    if (!handles.length) {
      mount.innerHTML = emptyHTML();
      return;
    }
    mount.innerHTML = '<div class="sx-skeleton" style="height:240px"></div>';
    var fetched = [];
    var pending = handles.length;
    handles.forEach(function (h) {
      fetch((((window.routes&&window.routes.cart_url)||'/cart').replace(/cart$/,''))+'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) fetched.push(p); })
        .catch(function () {})
        .then(function () {
          pending -= 1;
          if (pending === 0) {
            // keep saved order
            var ordered = handles
              .map(function (h2) {
                return fetched.filter(function (p) { return p.handle === h2; })[0];
              })
              .filter(Boolean);
            if (!ordered.length) {
              mount.innerHTML = emptyHTML();
              return;
            }
            mount.innerHTML =
              '<div class="sx-saved-grid">' + ordered.map(cardHTML).join('') + '</div>';
            /* WHITEBG-1021: swap in the white background-removed photo when the product has one (templates/product.sx-cw.liquid) */
            mount.querySelectorAll('[data-sx-saved-card]').forEach(function (card) {
              var im = card.querySelector('.sx-card__media img');
              if (!im) return;
              fetch((((window.routes&&window.routes.cart_url)||'/cart').replace(/cart$/,''))+'products/' + card.getAttribute('data-sx-saved-card') + '?view=sx-cw')
                .then(function (r) { return r.ok ? r.json() : ''; })
                .then(function (u) { if (u && typeof u === 'string') im.src = u + '?width=400'; })
                .catch(function () {});
            });
            mount.querySelectorAll('[data-sx-remove]').forEach(function (btn) {
              btn.addEventListener('click', function (e) {
                e.preventDefault();
                toggle(btn.getAttribute('data-sx-remove'));
                renderSaved(mount);
              });
            });
          }
        });
    });
  }

  function init() {
    syncCount();
    bindHearts();
    var mount = document.querySelector('[data-sx-saved-mount]');
    if (mount) renderSaved(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // re-bind hearts after section re-renders (variant change, etc.)
  document.addEventListener('shopify:section:load', bindHearts);

  // Re-bind grid-card hearts when the collection grid re-renders via facet/sort
  // AJAX — Dawn swaps #ProductGridContainer contents without firing section:load,
  // so freshly-rendered cards would otherwise have inert hearts.
  var sxGridEl = document.getElementById('ProductGridContainer');
  if (sxGridEl) {
    new MutationObserver(function () { bindHearts(); }).observe(sxGridEl, { childList: true, subtree: true });
  }

  window.SXWishlist = {
    read: read,
    has: has,
    toggle: toggle,
    count: count,
    render: renderSaved,
    syncCount: syncCount,
    bindHearts: bindHearts
  };
})();
